import { DiscountType } from '@app-types/discount';

export function getPromoDuration(discounts: DiscountType[] | undefined): number {
    if (!discounts || discounts.length === 0) {
        return 0;
    }
    return discounts.reduce((total, promo) => total + promo.duration, 0);
}
